export enum ProjectType {
    Standard = 0,
    Static = 1,
    Cloud = 2
}

export enum AccessType {
    ViewOnly = 0,
    Standard = 1,
    Admin = 2
}

export enum Units {
    Meters = "m",
    Feet = "ft",
    SurveyFeet = "sft"
}